import { Types } from '../Constants/Types';
import CityV2Type from '../Interfaces/citiesV2.interface';
import { initialErrors } from '../Constants/CitiesV2.constants';

const CitiesV2Reducer = (
  state: CityV2Type['status'] = {
    citiesV2: [],
    lcitiesV2: false,
    lcityV2: false,
    error: initialErrors,
    pages: 0,
    total: 0,
  },
  action: CityV2Type['action'],
) => {
  switch (action.type) {
    case Types.FETCH_CITIES_V2:
      return {
        ...state,
        citiesV2: action.payload,
        pages: action.pages,
        total: action.total,
      };
    case Types.START_CITIES_V2:
      return { ...state, lcitiesV2: true };
    case Types.END_CITIES_V2:
      return { ...state, lcitiesV2: false };
    case Types.START_CITY_V2:
      return { ...state, lcityV2: true };
    case Types.END_CITY_V2:
      return { ...state, lcityV2: false };
    case Types.CREATE_CITY_V2:
      return {
        ...state,
        citiesV2: [action.payload, ...state.citiesV2],
        total: state.total + 1,
      };
    case Types.UPDATE_CITY_V2:
      return {
        ...state,
        citiesV2: state.citiesV2.map((city) =>
          city._id === action.payload._id ? action.payload : city,
        ),
      };
    case Types.ERROR_CITIES_V2:
      return {
        ...state,
        error: { ...state.error, [action.field as string]: action.payload },
      };
    case Types.RESET_CITIES_V2:
      return { ...state, error: initialErrors };
    default:
      return state;
  }
};

export default CitiesV2Reducer;
